import { brandHeader, brandLogo, brandTenantName, brandAppTitle, signInWrap, signInInput, signInFieldError, signInAccountNote, signInFooter, signInFooterLink, } from './signInStyles.js';
import { mfaButton, mfaCard, mfaError, mfaForm, mfaLabel, mfaSubtitle } from './mfaStyles.js';
export const signInV1 = {
    wrap: signInWrap,
    card: mfaCard,
    header: brandHeader,
    logo: brandLogo,
    tenantName: brandTenantName,
    appTitle: brandAppTitle,
    subtitle: mfaSubtitle,
    form: mfaForm,
    label: mfaLabel,
    input: signInInput,
    fieldError: signInFieldError,
    error: mfaError,
    button: mfaButton,
    accountNote: signInAccountNote,
    footer: signInFooter,
    footerLink: signInFooterLink,
};
const ink = 'hsl(var(--ink))';
const ink2 = 'hsl(var(--ink-2))';
const ink3 = 'hsl(var(--ink-3))';
export const signInV2 = {
    rootClassName: 'ui-v2',
    wrap: { ...signInWrap, background: 'hsl(var(--background))' },
    card: {
        width: '100%',
        maxWidth: 420,
        borderRadius: 12,
        background: '#ffffff',
        padding: '26px 30px',
    },
    header: brandHeader,
    logo: brandLogo,
    tenantName: { margin: '0.75rem 0 0', fontSize: 14, fontWeight: 500, color: ink2 },
    appTitle: { margin: '0.25rem 0 0', fontSize: 24, fontWeight: 600, color: ink },
    subtitle: { marginTop: '0.5rem', textAlign: 'center', fontSize: 15, color: ink2, lineHeight: 1.7 },
    form: { marginTop: '1.25rem', display: 'flex', flexDirection: 'column', gap: '1rem' },
    label: { display: 'block', fontSize: 14, fontWeight: 500, color: ink2 },
    input: {
        marginTop: '0.375rem',
        width: '100%',
        boxSizing: 'border-box',
        border: 'none',
        borderRadius: 8,
        background: 'hsl(var(--surface-2))',
        padding: '8px 14px',
        fontSize: 15,
        color: ink,
        outlineColor: 'hsl(var(--brand))',
    },
    fieldError: { margin: '0.375rem 0 0', fontSize: 14, color: 'hsl(var(--danger-ink))' },
    error: {
        margin: 0,
        background: 'hsl(var(--surface-2))',
        borderRadius: 8,
        padding: '12px 18px',
        fontSize: 14,
        color: 'hsl(var(--danger-ink))',
    },
    button: (disabled) => ({
        display: 'inline-flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'hsl(var(--brand))',
        opacity: disabled ? 0.5 : 1,
        color: '#ffffff',
        fontSize: 15,
        fontWeight: 500,
        padding: '8px 20px',
        borderRadius: 8,
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
    }),
    accountNote: { margin: '1rem 0 0', fontSize: 14, color: ink3, lineHeight: 1.7 },
    footer: { marginTop: '1.25rem', textAlign: 'center', fontSize: 13, color: ink3, lineHeight: 1.8 },
    footerLink: { color: ink2, textDecoration: 'underline' },
};
//# sourceMappingURL=signInStylesV2.js.map